import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

export class MonsterLvl5Handler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.MONSTER_LVL_5);
    }
}
